export const downloadBlob = (data, fileName) => {
  const url = window.URL.createObjectURL(new Blob([data]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', extractDisplayName(fileName))
  document.body.appendChild(link)
  link.click()
}

export const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      const base64String = reader.result.split(',')[1]
      resolve(base64String)
    }
    reader.onerror = () => {
      reject(new Error('Failed to convert blob to base64'))
    }
    reader.readAsDataURL(blob)
  })
}

export const extractDisplayName = (filePath) => {
  if (!filePath) return ''
  const fileName = filePath.split('/').pop()

  const lastDashIndex = fileName.lastIndexOf('-')
  const lastDotIndex = fileName.lastIndexOf('.')

  if (lastDashIndex !== -1 && lastDotIndex !== -1) {
    return fileName.substring(0, lastDashIndex) + fileName.substring(lastDotIndex)
  }

  return fileName
}
